import { useState, useEffect } from 'react';
import { get_auth } from '../auth';
import { serverUrl } from '../ConfigHolder';


function useEmailVerification(triggerPolling, interval = 5000, maxAttempts = 60) {
  const [isVerified, setIsVerified] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const [verificationError, setVerificationError] = useState()

  useEffect(() => {
    let attempts = 0;
    let timer;
    const route = "verify-status"
    if (triggerPolling) {
     timer = setInterval(async () => {
      attempts++;
      if (attempts > maxAttempts) {
        clearInterval(timer);
        setVerifying(false);
        setIsVerified(false);
        return;
      }

      try {
        let uri = `${serverUrl}/${route}`
        const response = await get_auth(uri, {}, 'json');
        if (response.data && response.data.verified) {
          setIsVerified(true);
          clearInterval(timer);
          setVerifying(false);
        }
      } catch (error) {
        console.error(`Error "${route}":`, error);
        setVerifying(false);
        setIsVerified(false);
        clearInterval(timer);
        setVerificationError(error);
        return;
      }
    }, interval);
    }
    return () => clearInterval(timer);
  }, [triggerPolling, interval, maxAttempts]);

  return { isVerified, verifying , verificationError};
}

export default useEmailVerification;
